import React from 'react';
import PaginationMui, { PaginationProps } from '@material-ui/lab/Pagination';

export const Pagination: React.FC<PaginationProps> = ({ ...rest }) => {
	return <PaginationMui dir="ltr" {...rest} />;
};
